import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DsbFormWidget from 'components/DsbFormWidget';
import Head from 'components/Head';
import cns from 'classnames';
import ChevronLeftIcon from 'components/icons/ChevronLeftIcon.com.svg';
import ChevronRightIcon from 'components/icons/ChevronRightIcon.com.svg';
import CarMagnifierIcon from 'components/icons/CarMagnifierIcon.com.svg';
import { getSearchUrl, getFaqUrl } from 'helpers/namedUrls';
import * as actions from '../actions';
import { reducer } from '../duck';
import mapStateToProps from './mapStateToProps';
import cn from './styles.local.less';

class NotFound extends PureComponent {
  static propTypes = {
    loadDsbMainWidget: PropTypes.func.isRequired,
    dsbMainWidgetProps: PropTypes.object,
  };

  render() {
    const { loadDsbMainWidget, dsbMainWidgetProps } = this.props;

    return (
      <Fragment>
        <Head />
        <div className={cns(cn.backLinkContainer, 'back-link-container')}>
          <a href={getSearchUrl()} className={cn.backLink}>
            <ChevronLeftIcon className={cn.arrowIcon} />
            {__('notFoundPage.backToHomeTopLink')}
          </a>
        </div>
        <div className={cn.root}>
          <div className={cn.headingSection}>
            <div className={cn.titleSection}>
              <CarMagnifierIcon className={cn.magnifierIcon} />
              <p className={cn.title}>404</p>
            </div>
            <h1 className={cn.heading}>{__('notFoundPage.title')}</h1>
            <p className={cn.description}>{__('notFoundPage.description')}</p>
          </div>
          <div className={cn.searchWidget}>
            <p className={cn.searchTitle}>{__('notFoundPage.searchTitle')}</p>
            <DsbFormWidget
              onWidgetLoad={loadDsbMainWidget}
              {...dsbMainWidgetProps}
            />
          </div>
          <div className={cn.subHeadingSection}>
            <h2 className={cn.subHeading}>{__('notFoundPage.otherLinks')}</h2>
            <div className={cn.linksSection}>
              <div>
                <a href={getSearchUrl()}>
                  <ChevronRightIcon className={cn.arrowIcon} />
                  {__('notFoundPage.backToHomeLink')}
                </a>
              </div>
              <div>
                <a href={getFaqUrl()}>
                  <ChevronRightIcon className={cn.arrowIcon} />
                  {__('notFoundPage.faqsLink')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, actions)(NotFound);

export { reducer, actions };
